<template>
  <div class="default-table orders-table">
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="permissions.orders.actions.new"
          v-on="on"
          @click.prevent="newDialog()"
          color="primary"
          class="mb-9"
          app
          fab
          bottom
          right
          fixed
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.orders.new.title }}</span>
    </v-tooltip>
    <orderSave
      v-if="permissions.orders.actions.new && dialog.selected"
      v-model="dialog.selected"
      :id="dialog.selected.id"
      :dialog="dialog.save"
      @closed="onCloseSave"
    />
    <orderView
      v-if="dialog.selected"
      :value="dialog.selected"
      :dialog="dialog.view"
      @closed="onCloseView"
      @edit="editDialog($event)"
    />
    <DataTable
      name="orders"
      :items="get_data.orders"
      :tablehdrs="tablehdrs"
      :search="true"
    >
      <template v-slot:default="{ item }">
        <tr
          :key="item.id"
          @dblclick="viewDialog(item)"
          class="mobile_row table-row order-row"
          :class="getClasses(item)"
        >
          <td class="id-col">
            <v-tooltip right v-if="!item.read">
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" class="order-alert">
                  <v-icon small color="red">mdi-exclamation-thick</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.view.unread }}</span>
            </v-tooltip>
            <strong># {{ item.id }}</strong>
          </td>
          <td class="datetime-col">
            {{ formatDate(item.datetime) }}
          </td>
          <td class="customer-col">
            <CustomerCard v-model="item.customer" :noneRef="item.ref" hideId />
          </td>
          <!-- <td>
            <v-chip
              dark
              class="type-chip"
            >
              {{ (item.type === 2 ? `${lang.orders.new.table} ${item.delivery.table}` : lang.orders.type.delivery) }}
            </v-chip>
          </td> -->
          <td class="status-col">
            <v-chip
              dark
              :color="getStatus(item.status).color"
              class="status-chip"
            >
              <v-icon small v-text="getStatus(item.status).icon" class="mr-2" />
              {{ getStatus(item.status).title }}
            </v-chip>
          </td>
          <td>
            <v-chip
              dark
              :color="getPaid(item).color"
              class="paid-chip"
            >
              {{ getPaid(item).title }}
            </v-chip>
          </td>
          <td v-if="permissions.orders.viewprices" class="total-col">
            <span class="text-body-1 font-weight-black">{{ formatCurrency(item.total) }}</span>
          </td>
          <td class="actions-col">
            <Actions
              :value="item"
              @input="updateOrderRow"
              @view="viewDialog(item)"
              @edit="editDialog(item)"
            />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item, isExpanded, expand }">
        <tr
          :key="`mb-${item.id}`"
          @click="expand(!isExpanded)"
          @dblclick="viewDialog(item)"
          class="mobile_row table-row order-row"
          :class="getClasses(item)"
        >
          <td class="mobile_col">
            <ul class="flex-content pl-2">
              <li class="flex-item" :data-label="`${lang.orders.datatable.headers.id}:`">
                <v-tooltip right v-if="!item.read">
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" class="order-alert">
                      <v-icon small color="red">mdi-exclamation-thick</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.view.unread }}</span>
                </v-tooltip>
                <strong># {{ item.id }}</strong>
              </li>
              <li class="flex-item" :data-label="`${lang.orders.datatable.headers.datetime}:`">
                {{ formatDate(item.datetime) }}
              </li>
              <li class="flex-item" :data-label="`${lang.orders.datatable.headers.customer}:`">
                <CustomerCard v-model="item.customer" :noneRef="item.ref" hideId />
              </li>
              <!-- <li class="flex-item" :data-label="`${lang.orders.datatable.headers.type}:`">
                {{ (item.type === 2 ? `${lang.orders.new.table} ${item.delivery.table}` : lang.orders.type.delivery) }}
              </li> -->
              <li class="flex-item" :data-label="`${lang.orders.datatable.headers.status}:`">
                <v-chip
                  dark
                  :color="getStatus(item.status).color"
                  class="status-chip"
                >
                  <v-icon small v-text="getStatus(item.status).icon" class="mr-2" />
                  {{ getStatus(item.status).title }}
                </v-chip>
              </li>
              <li class="flex-item" :data-label="`${lang.orders.datatable.headers.paid}:`">
                <v-chip
                  dark
                  :color="getPaid(item).color"
                  class="paid-chip"
                >
                  {{ getPaid(item).title }}
                </v-chip>
              </li>
              <li v-if="permissions.orders.viewprices" :data-label="`${lang.orders.datatable.headers.total}:`" class="total-col flex-item">
                <span class="text-body-1 font-weight-black">
                  {{ formatCurrency(item.total) }}
                </span>
              </li>
              <li class="flex-item actions_row" :data-label="lang.orders.datatable.headers.action">
                <Actions
                  :value="item"
                  @input="updateOrderRow"
                  @view="viewDialog(item)"
                  @edit="editDialog(item)"
                />
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import CustomerCard from '@/components/customers/templates/OrderCard'
import orderSave from './Save'
import orderView from './View'

import Actions from './templates/Actions'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import listDefaults from '@/mixins/defaults/list'
import orders from './mixins/index'

export default {
  components: { DataTable, CustomerCard, Actions, orderSave, orderView },
  mixins: [ appdata, utils, listDefaults, orders ],
  data: () => ({
    default: { ...defaults.blank.order }
  }),
  computed: {
    tablehdrs: {
      get: function () {
        const ordersdtbhdr = this.tableheaders.orders
        if (!this.permissions.orders.viewprices) {
          const totalheader = ordersdtbhdr.find(element => element.value === 'total')
          if (totalheader) {
            const index = ordersdtbhdr.indexOf(totalheader)
            ordersdtbhdr.splice(index, 1)
          }
        }
        return ordersdtbhdr
      }
    }
  },
  created () {
    if (this.routerPath && this.routerPath.action === 'repeat') {
      this.newDialog()
    }
  }
}
</script>

<style src="./styles/list.scss" lang="scss"></style>
